import { SupportAnswer, SupportAskResponseBody, SupportVideo } from "../../../interfaces/SupportObject";

// Support Agent responseBody is already camelCase (NineBusinessRs convention)
// — this converter only null-guards so a malformed/partial answer can never
// crash the UI. Caller (SupportApiService) has already confirmed the envelope
// reported success before this runs.

const MAX_FOLLOW_UPS = 3; // API doc: 0–3 suggested follow-ups
const MAX_VIDEOS = 2; // API doc: 0–2 videos per answer, never more

/** Drops any video entry that's missing what the player actually needs — a
 *  malformed entry (no url) would otherwise render a dead click-to-play card. */
function isPlayableVideo(v: unknown): v is SupportVideo {
  const video = v as Partial<SupportVideo> | null;
  return (
    !!video &&
    typeof video.url === "string" &&
    video.url.trim().length > 0 &&
    typeof video.videoId === "string" &&
    typeof video.title === "string" &&
    typeof video.mediaType === "string"
  );
}

export function convertSupportAnswer(raw: SupportAskResponseBody): SupportAnswer {
  return {
    answer:
      typeof raw?.answer === "string" && raw.answer.trim().length > 0
        ? raw.answer
        : "Sorry, I couldn't come up with an answer for that. Could you try rephrasing?",
    suggestedFollowUps: Array.isArray(raw?.suggestedFollowUps)
      ? raw.suggestedFollowUps
          .filter((s): s is string => typeof s === "string" && s.trim().length > 0)
          .slice(0, MAX_FOLLOW_UPS)
      : [],
    videos: Array.isArray(raw?.videos)
      ? raw.videos.filter(isPlayableVideo).slice(0, MAX_VIDEOS)
      : [],
  };
}
